import React from 'react'
import './Section.css'

const Section = ({children, contStyle, customClass}) => {
    return (
        <div className={customClass ? customClass : "content-section"} style={contStyle && contStyle}>
            { children }
        </div>
    )
}

export default Section
